<template>
  <div class="page-con">
    <div class="header">
      <img class="logo-left" @click="toggleFullScreen" src="https://cdn.spbcn.org/ITSO_WEB/screen2015/left_1.png" alt="">
      <div class="logo-center" @click="refresh">
        <img src="https://cdn.spbcn.org/ITSO_WEB/20160515/center_1.png" alt="">
      </div>
      <!-- <img class="logo-right" @click="refresh" src="https://cdn.spbcn.org/ITSO_WEB/screen2015/right.png" alt=""> -->
    </div>
    <div class="flex">
      <div class="item">
        <div class="title-box">
          <div class="title">积分排名</div>
          <div class="en-title">Points Ranking</div>
        </div>
        <div class="box">
          <div class="box-tit">
            <div class="w1">
              <div class="cn">学校(战队)</div>
              <div class="en">School (Team)</div>
            </div>
            <div class="w5">
              <div class="cn">场次</div>
              <div class="en">Session</div>
            </div>
            <div class="w2">
              <div class="cn">胜/平/负</div>
              <div class="en">Win/Draw/Loss</div>
            </div>
            <div class="w2">
              <div class="cn">得/失</div>
              <div class="en">Points Earned/Lost</div>
            </div>
            <div class="w5">
              <div class="cn">积分</div>
              <div class="en">Points</div>
            </div>
          </div>
          <div class="ranking-wrapper">
            <div class="ranking-list" :style="scrollStyle">
              <div class="group-item" v-for="(group, index) in rankingData" :key="index">
                <div v-for="(item, j) in group" :key="j">
                  <div class="group-name" v-if="j === 0">{{ item.name }} {{ item.level }}{{ item.groupName }}</div>
                  <div class="list-item">
                    <div class="w1">
                      <div class="team">
                        <div class="ava">
                          <img :src="item.clubLogo" alt="">
                          <!-- <img src="https://cdn.spbcn.org/spbcnappneed/ITSO_logo_V2.png" alt=""> -->
                        </div>
                        <div class="flex1">
                          <div class="school-name">{{ item.school }}</div>
                          <div class="team-name">{{ item.team }}</div>
                          <!-- <div class="school-name">北京AAA学校</div>
                          <div class="team-name">AAA战队</div> -->
                        </div>
                      </div>
                    </div>
                    <div class="w2 num">{{ item.num }}</div>
                    <div class="w2 num">{{ item.winPartLose }}</div>
                    <div class="w2 num">{{ item.winLose }}</div>
                    <div class="w2 num">{{ item.point }}</div>
                  </div>
                </div>
              </div>
              <div class="group-item" v-for="(group, index) in rankingData" :key="'copy-' + index">
                <div v-for="(item, j) in group" :key="j">
                  <div class="group-name" v-if="j === 0">{{ item.name }} {{ item.level }}{{ item.groupName }}</div>
                  <div class="list-item">
                    <div class="w1">
                      <div class="team">
                        <div class="ava">
                          <img :src="item.clubLogo" alt="">
                          <!-- <img src="https://cdn.spbcn.org/spbcnappneed/ITSO_logo_V2.png" alt=""> -->
                        </div>
                        <div class="flex1">
                          <div class="school-name">{{ item.school }}</div>
                          <div class="team-name">{{ item.team }}</div>
                          <!-- <div class="school-name">北京AAA学校</div>
                          <div class="team-name">AAA战队</div> -->
                        </div>
                      </div>
                    </div>
                    <div class="w2 num">{{ item.num }}</div>
                    <div class="w2 num">{{ item.winPartLose }}</div>
                    <div class="w2 num">{{ item.winLose }}</div>
                    <div class="w2 num">{{ item.point }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="time-str">
          <!-- <div>{{ date }}</div> -->
          <div>起 {{ startTime }}</div>
          <div>止 {{ endTime }}</div>
        </div>
        <div class="title-box">
          <div class="title">对阵信息</div>
          <div class="en-title">Matchup Information</div>
        </div>
        <div class="box">
          <div class="box-tit">
            <div class="w5">
              <div class="cn">考场</div>
              <div class="en">Room</div>
            </div>
            <div class="w5">
              <div class="cn">组别</div>
              <div class="en">Level</div>
            </div>
            <div class="w3">
              <div class="cn">学校(战队)对战</div>
              <div class="en">Schools (Teams) Matches</div>
            </div>
            <!-- <div class="w6">
              <div class="cn">起止时间</div>
              <div class="en">Start and End Time</div>
            </div> -->
          </div>
          <div class="list-item" v-for="(item, index) in teamList" :key="index">
            <div class="w5">
              <div class="center">{{ item.roomname }}</div>
            </div>
            <div class="w5">
              <div class="center1">{{ formatLevel(item.level) }}</div>
            </div>
            <div class="w3 line">
              <div class="team">
                <div class="ava">
                  <img :src="item.club1logo" alt="">
                  <!-- <img src="https://cdn.spbcn.org/spbcnappneed/ITSO_logo_V2.png" alt=""> -->
                </div>
                <div class="flex2">
                  <div class="school-name">{{ item.s1name }}</div>
                  <div class="team-name">{{ item.school1name }}</div>
                  <!-- <div class="school-name">北京AAA学校</div>
                  <div class="team-name">AAA战队</div> -->
                </div>
              </div>
              <div class="vs">VS</div>
              <div class="team">
                <div class="ava">
                  <img :src="item.club2logo" alt="">
                  <!-- <img src="https://cdn.spbcn.org/spbcnappneed/ITSO_logo_V2.png" alt=""> -->
                </div>
                <div class="flex2">
                  <div class="school-name">{{ item.s2name }}</div>
                  <div class="team-name">{{ item.school2name }}</div>
                  <!-- <div class="school-name">杭州BBB学校</div>
                  <div class="team-name">BBB战队</div> -->
                </div>
              </div>
            </div>
            <!-- <div class="w6">
              <div class="time">
                <div>{{ item.sTime }}</div>
                <div>{{ item.eTime }}</div>
              </div>
            </div> -->
          </div>
          <div v-if="!teamList.length" class="default">
            <img src="https://cdn.spbcn.org/spbcnappneed/ITSO_logo_V2.png" alt="">
            <div>暂无对战信息</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      teamList: [],
      rankingData: [],
      scrollDuration: 0, // 根据数据长度计算持续时间
      timer: null,
      startTime: '',
      endTime: '',
      date: ''
    }
  },
  created () {
    this.refresh()
    this.interval()
  },
  computed: {
    scrollStyle () {
      return {
        animationDuration: `${this.scrollDuration}s`,
        animationPlayState: this.isPaused ? 'paused' : 'running'
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    interval () {
      this.timer = setInterval(() => {
        this.refresh()
      }, 10000)
    },
    formatLevel (level) {
      const levels = ['小学组', '初中组', '高中组']
      return levels[level]
    },
    refresh () {
      this.getScores()
      this.getTeams()
    },
    getScores () {
      this.$http.get('common/itsoReferee/largeScreenPoints').then(res => {
        if (res.code === 200) {
          this.rankingData = []
          // 小学组
          if (res.data.primary && res.data.primary.length) {
            const primary = res.data.primary[0]
            // 按A-Z排序
            primary.list.sort((a, b) => a.groupName.localeCompare(b.groupName))
            // 按A B C分组
            const groupedPrimary = primary.list.reduce((acc, obj) => {
              obj = { ...obj, ...{ level: '小学组', name: primary.name } }
              obj.school = obj.teamName.split('(')[0]
              obj.team = obj.teamName.split('(')[1].slice(0, -1)
              const foundGroup = acc.find(group => group[0].groupName === obj.groupName)
              if (foundGroup) {
                foundGroup.push(obj)
              } else {
                acc.push([obj])
              }
              return acc
            }, [])
            // console.log(groupedPrimary)
            this.rankingData = [...groupedPrimary, ...this.rankingData]
          }

          // 初中组
          if (res.data.middle && res.data.middle.length) {
            const middle = res.data.middle[0]
            // 按A-Z排序
            middle.list.sort((a, b) => a.groupName.localeCompare(b.groupName))
            // 按A B C分组
            const groupedMiddle = middle.list.reduce((acc, obj) => {
              obj = { ...obj, ...{ level: '初中组', name: middle.name } }
              obj.school = obj.teamName.split('(')[0]
              obj.team = obj.teamName.split('(')[1].slice(0, -1)
              const foundGroup = acc.find(group => group[0].groupName === obj.groupName)
              if (foundGroup) {
                foundGroup.push(obj)
              } else {
                acc.push([obj])
              }
              return acc
            }, [])
            // console.log(groupedMiddle)
            this.rankingData = [...groupedMiddle, ...this.rankingData]
          }

          // 高中组
          if (res.data.high && res.data.high.length) {
            const high = res.data.high[0]
            // 按A-Z排序
            high.list.sort((a, b) => a.groupName.localeCompare(b.groupName))
            // 按A B C分组
            const groupedHigh = high.list.reduce((acc, obj) => {
              obj = { ...obj, ...{ level: '高中组', name: high.name } }
              obj.school = obj.teamName.split('(')[0]
              obj.team = obj.teamName.split('(')[1].slice(0, -1)
              const foundGroup = acc.find(group => group[0].groupName === obj.groupName)
              if (foundGroup) {
                foundGroup.push(obj)
              } else {
                acc.push([obj])
              }
              return acc
            }, [])
            // console.log(groupedHigh)
            this.rankingData = [...groupedHigh, ...this.rankingData]
          }

          this.scrollDuration = this.rankingData.length * 8
          console.log(this.rankingData)
        }
      })
    },

    getTeams () {
      this.$http.get('common/itsoReferee/largeScreenMatchs', { params: { pageNum: 1, pageSize: 10 } }).then(res => {
        if (res.code === 200) {
          if (res.data.length) {
            this.startTime = res.data[0].timestr.split('-')[0]
            this.endTime = res.data[0].timestr.split('-')[1]
            // this.date = res.data[0].timestr.split('-')[0].slice(0, 10)
            // res.data.forEach(item => {
            //   item.sTime = res.data[0].timestr.split('-')[0].slice(11, 19)
            //   item.eTime = res.data[0].timestr.split('-')[1].slice(11, 19)
            // })
          }
          this.teamList = res.data
        }
      })
    },

    toggleFullScreen () {
      if (!document.fullscreenElement) {
        this.enterFullScreen()
      } else {
        this.exitFullScreen()
      }
    },
    // 全屏
    enterFullScreen () {
      const element = document.documentElement
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) { /* Firefox */
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) { /* IE/Edge */
        element.msRequestFullscreen()
      }
    },
    // 退出全屏
    exitFullScreen () {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.page-con{
  background: linear-gradient(to bottom, #f29d00, #ec6e21);
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  padding: 0 20px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.header{
  height: 124px;
  position: relative;
  flex-shrink: 0;
  .logo-left{
    height: 50px;
    width: auto;
    position: absolute;
    left: 40px;
    top: 38px;
  }
  .logo-right{
    height: 50px;
    width: auto;
    position: absolute;
    right: 40px;
    top: 26px;
  }
  .logo-center{
    width: 100%;
    text-align: center;
    padding-top: 10px;
    img{
      height: 180px;
      width: auto;
    }
  }
}

.flex{
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  overflow: hidden;
  padding-bottom: 20px;
}
.title-box{
  background-color: rgba(41, 28, 25, .8);
  margin: 0 auto;
  padding: 10px 20px 6px;
  border-radius: 16px 16px 0 0;
  display: inline-block;
}
.title{
  font-family: hzgb;
  font-size: 36px;
  text-align: center;
  color: #fff;
  // -webkit-text-stroke: 1px white;
  // text-shadow: 0 0 2px white, /* 可选，用于柔化边缘 */
  //   0 0 2px white; /* 可选，用于更宽的发光效果 */
  margin-bottom: 4px;
}
.en-title{
  font-family: hzgb;
  font-size: 16px;
  text-align: center;
  color: #fff;
  // -webkit-text-stroke: 1px white;
  // text-shadow: 0 0 1px white, /* 可选，用于柔化边缘 */
  //   0 0 1px white; /* 可选，用于更宽的发光效果 */
}
.item{
  width: 50%;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  .time-str{
    position: absolute;
    top: 20px;
    right: 30px;
    font-size: 18px;
    font-weight: 900;
    color: #000;
  }
}
.box{
  // margin-top: 14px;
  margin-left: 10px;
  margin-right: 10px;
  background-color: #fff;
  border-radius: 20px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.box-tit{
  background-color: #151515;
  border-radius: 20px 20px 0 0;
  color: #fff;
  padding: 6px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  flex-shrink: 0;
  .cn{
    font-size: 24px;
    font-weight: 900;
  }
  .en{
    font-size: 14px;
  }
}
.w1{
  width: 44%;
}
.w2{
  width: 15%;
  text-align: center;
}
.w3{
  width: 80%;
}
.w6{
  width: 20%;
}
.w4{
  width: 16%;
}
.w5{
  width: 10%;
}

.group-name{
  background-color: #291c19;
  text-align: center;
  color: #fff;
  font-size: 18rpx;
  padding: 2px 0;
}

.list-item{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px solid #150F0F;
  &:nth-child(11){
    border: none;
  }
}
.line{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.team{
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  .ava{
    width: 50px;
    height: 50px;
    // background-color: #f0a21e;
    border-radius: 50px;
    margin-right: 8px;
    margin-left: 20px;
    overflow: hidden;
    text-align: center;
    img{
      width: 50px;
      height: auto;
    }
  }
  .flex1{
    width: 300px;
    overflow: hidden;
  }
  .school-name{
    font-size: 18px;
    color: #000;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    width: 280px;
  }
  .team-name{
    color: #fff;
    font-size: 16px;
    font-weight: 900;
    background-color: #f0a21e;
    padding: 2px 6px;
    display: inline-block;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
  }
  .flex2{
    // width: 200px;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    .school-name{
      // width: 194px;
    }
    .team-name{
      // max-width: 194px;
    }
  }
}
.vs{
  font-size: 20px;
  font-family: hzgb;
  font-weight: bold;
  color: #000;
}
.center{
  color: #000;
  font-size: 18px;
  font-family: hzgb;
  text-align: center;
}
.center1{
  color: #000;
  font-size: 18px;
  font-family: hzgb;
  text-align: center;
}
.time{
  font-size: 16px;
  color: #000;
  font-family: hzgb;
  text-align: center;
  line-height: 24px;
}
.num{
  text-align: center;
  font-size: 20px;
  font-family: hzgb;
}

.ranking-wrapper {
  flex: 1;
  overflow: hidden;
  position: relative;
}

.ranking-list {
  position: absolute;
  animation: scroll linear infinite;
  left: 0;
  right: 0;
}

@keyframes scroll {
  0% { transform: translateY(0); }
  100% { transform: translateY(-50%); }
}
.default{
  color: #606266;
  font-size: 14px;
  text-align: center;
  padding-top: 240px;
  img{
    width: 140px;
  }

}
</style>
